import { useMemo } from 'react';
import type { Control, FieldValues, Path } from 'react-hook-form';

import { defaultCountryCodeValues } from '@xing-com/crate-jobs-domain-apply-helpers';
import { useCountryCodes } from '@xing-com/crate-jobs-domain-apply-hooks';

import { DropdownField } from './dropdown-field';

type Props<T extends FieldValues> = {
  control: Control<T>;
  path: Path<T>;
  required?: boolean;
};

export const CountryCodeField = <T extends FieldValues>({
  path,
  control,
  required = false,
}: Props<T>): React.ReactElement => {
  const countries = useCountryCodes();
  const options = useMemo(
    () =>
      (countries ?? defaultCountryCodeValues).map(
        ({ name, dialCode, countryCode }) => ({
          key: countryCode,
          value: countryCode,
          label: `${name} (+${dialCode})`,
        })
      ),
    [countries]
  );

  return (
    <DropdownField
      control={control}
      path={path}
      placeholderCopy="JOBS_INSTANT_APPLY_FORM_COUNTRY_CODE_LABEL"
      required={required}
      options={options}
    />
  );
};
